import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import JsBarcode from 'jsbarcode';
import { LanguageContext } from '../../../LanguageContext';
import { downloadBarcodeLabel } from './downloadBarcodeLabel';

const BarcodePrint = () => {
    const { lang, langdetect } = React.useContext(LanguageContext);
    const location = useLocation();
    const canvasRef = useRef(null);

    const params = new URLSearchParams(location.search);
    const barcode = (params.get('code') || '').trim();
    const sku = (params.get('sku') || '').trim();
    const productName = (params.get('name') || '').trim();

    useEffect(() => {
        if (!barcode || !canvasRef.current) return;
        try {
            JsBarcode(canvasRef.current, barcode, {
                format: 'CODE128',
                width: 2,
                height: 100,
                displayValue: false,
                margin: 10,
                background: '#ffffff',
                lineColor: '#000000',
            });
        } catch (e) {
            console.error(e);
        }
    }, [barcode]);

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = () => {
        downloadBarcodeLabel(barcode, { sku, productName });
    };

    if (!barcode) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', fontFamily: 'system-ui, sans-serif' }}>
                <p style={{ color: '#6b7280' }}>{langdetect == 'en' ? 'No barcode provided.' : 'لا يوجد باركود.'}</p>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', background: '#f3f4f6', fontFamily: 'system-ui, sans-serif' }}>
            <style>{`
                @media print {
                    body { background: #fff !important; margin: 0; }
                    .bp-actions { display: none !important; }
                    .bp-page { background: #fff !important; min-height: auto !important; padding: 0 !important; }
                    .bp-card { box-shadow: none !important; border: none !important; padding: 24px !important; }
                }
            `}</style>
            <div className="bp-page" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 16px' }}>
                <div className="bp-actions" style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
                    <button
                        type="button"
                        onClick={handlePrint}
                        style={{
                            border: '1px solid #d1d5db',
                            background: '#111827',
                            color: '#fff',
                            borderRadius: 8,
                            padding: '10px 18px',
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    >
                        {lang.print || (langdetect == 'en' ? 'Print' : 'اطبع')}
                    </button>
                    <button
                        type="button"
                        onClick={handleDownload}
                        style={{
                            border: '1px solid #d1d5db',
                            background: '#fff',
                            color: '#111827',
                            borderRadius: 8,
                            padding: '10px 18px',
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    >
                        {langdetect == 'en' ? 'Download' : 'تحميل'}
                    </button>
                </div>

                <div
                    className="bp-card"
                    style={{
                        background: '#fff',
                        borderRadius: 12,
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                        padding: '32px 40px',
                        display: 'inline-flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        gap: 4,
                    }}
                >
                    {productName ? (
                        <div
                            style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: '#111827',
                                textAlign: 'left',
                                lineHeight: 1.3,
                                alignSelf: 'stretch',
                            }}
                        >
                            {productName}
                        </div>
                    ) : null}
                    <canvas ref={canvasRef} style={{ display: 'block' }} />
                    <div
                        style={{
                            fontSize: 18,
                            fontWeight: 600,
                            letterSpacing: 2,
                            color: '#111827',
                            fontFamily: 'monospace',
                            textAlign: 'center',
                            direction: 'ltr',
                            marginTop: 8,
                        }}
                    >
                        {barcode}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BarcodePrint;
